import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardModule } from "../../dashboard.module";
import { AccountantService } from "../../main/accountant/accountant.service";
import { HotToastService } from "@ngneat/hot-toast";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DashboardService } from "../../dashboard.service";
import { DrawerComponent } from "./../drawer/drawer.component";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "client-info-section",
  imports: [CommonModule, DashboardModule, DrawerComponent, FormsModule],
  templateUrl: "./client-info-section.component.html",
  styleUrls: ["./client-info-section.component.scss"],
})
export class ClientInfoSectionComponent implements OnInit {
  constructor(
    private accountantService: AccountantService,
    private toastr: HotToastService,
    private modalService: BsModalService,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
  ) {}

  private _currentCompany: any;
  editingClientName: boolean = false;
  modalRef: BsModalRef;
  user_being_removed = null;
  new_owner = "";
  @Input() tags;
  @Input()
  set current_company(value: any) {
    this._currentCompany = value;
  }

  get current_company(): any {
    return this._currentCompany;
  }

  drawerOpen = false;
  isForClientDetails: boolean = false;

  changeHide(val: boolean) {
    this.drawerOpen = val;
  }

  ngOnInit(): void {
    console.log("CURRENT COMPANY", this.current_company);
    this.cdr.detectChanges();
  }

  addTag(tag) {
    console.log(tag);
    this.accountantService
      .addWorkspaceTag(this.current_company.company_conversation.uuid, tag.uuid)
      .then((res: any) => {
        this.tags.push(res);
      });
  }

  openDrawer() {
    this.isForClientDetails = true;
    this.cdr.detectChanges();
    this.drawerOpen = true;
  }

  removeTagFromWorkspace(tag) {
    this.accountantService
      .removeWorkspaceTag(
        this.current_company.company_conversation.uuid,
        tag.uuid,
      )
      .then(
        (res) => {
          this.toastr.success("Tag removed successfully.");

          this.tags = this.tags.filter((t) => {
            return t.uuid != tag.uuid;
          });
        },
        (err) => {
          this.toastr.error("Error removing tag.");
        },
      );
  }

  archiveCompany(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm",
    });
  }

  confirmArchivation(company_id): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService.archive_company(company_id).then(
      (res: any) => {
        const response = res;

        this.accountantService.archiveCompany.next({
          company_id: company_id,
          archived: response.archived,
        });

        this.dashboardService.show_loading.next(false);
        this.toastr.success(response.message);
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      },
    );
    this.modalRef.hide();
  }

  updateCompanyName(): void {
    if (this.current_company.name.trim() == "") {
      this.toastr.error("Please enter a valid name");
      return;
    }

    this.dashboardService.show_loading.next(true);
    this.accountantService
      .update_company_name(this.current_company.id, this.current_company.name)
      .then(
        (res: any) => {
          const response = res;
          this.editingClientName = false;

          this.accountantService.update_company_name_sub.next({
            company_id: this.current_company.id,
            name: this.current_company.name,
          });

          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        },
      );
  }

  declineArchivation(): void {
    this.modalRef.hide();
    this.new_owner = null;
    this.user_being_removed = null;
  }

  showDataField(dataField) {
    console.log(dataField);
  }
}
